import { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { explain } from '@/shared/api/problem'
import { ErrorStrip, LoadingBlock } from '@/shared/ui/states'
import { getReport, pinReport, type Report } from './api'
import { ReportView } from './components/ReportView'

/** One report on its own page — what a pinned link or a shared URL opens. */
export function ReportPage() {
  const { id = '' } = useParams()
  const [report, setReport] = useState<Report | null>(null)
  const [error, setError] = useState<string | null>(null)

  const load = useCallback(async () => {
    try {
      setError(null)
      setReport(await getReport(id))
    } catch (err) {
      setError(explain(err))
    }
  }, [id])

  useEffect(() => { void load() }, [load])

  return (
    <div className="space-y-3">
      <ErrorStrip message={error} className="rounded-md border" />
      {report === null && !error && <LoadingBlock />}
      {report && (
        <ReportView
          report={report}
          onPin={(pinned) => void pinReport(id, pinned).then(() => load())}
          onProposalChanged={() => void load()} />
      )}
    </div>
  )
}
